export default function (text) {
    if(!text)
        return ``

    return `${text.charAt(0).toUpperCase()}${text.toString().substring(1, text.length)}`
}